<template>
  <div>

    <ProjTab :current_tab="'Komunikacija'" :project_info="proj_data" />
    <div class="upload-dokumenta-button" @click="uploadStyling"
      v-if="is_permission_inside('project.comunication.create')">
      Upload dokumenta
      <div class="upload-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
          <g>
            <g>
              <path fill="#fff"
                d="M3.995 5.15a.738.738 0 0 1 .16-.805L8.29.214a.742.742 0 0 1 1.046 0l4.135 4.131a.74.74 0 0 1-.522 1.261h-1.807v5.357a.984.984 0 0 1-.985.983H7.47a.984.984 0 0 1-.984-.983V5.606H4.678a.74.74 0 0 1-.683-.456zm13.749 3.351v3.71C17.744 14.3 16.042 16 13.95 16H3.677a3.796 3.796 0 0 1-3.793-3.79V8.502a.888.888 0 0 1 1.776 0v3.71c0 1.11.904 2.015 2.017 2.015H13.95a2.019 2.019 0 0 0 2.018-2.016V8.501a.887.887 0 0 1 1.776 0z" />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="case-spisi">
      <div class="spisi-left">
        <div class="case-spisi-folders-line posta-folders-line">
          <div :class="[
            'section-square',
            'ulazna-posta',
            chosen_type == 0 ? 'active' : '',
          ]" @click="
  setPostFolder(input_mail_id);
chosen_type = 0;
activityFile = null;
">
            <img class="doc-icon" src="@/assets/img/ulazna_posta.svg" />
            <div>Ulazni Dokumenti</div>
          </div>
          <div :class="[
            'section-square',
            'ulazna-posta',
            chosen_type == 1 ? 'active' : '',
          ]" @click="
  setPostFolder(output_mail_id);
chosen_type = 1;
activityFile = null;
">
            <img class="doc-icon" src="@/assets/img/izlazna_posta.svg" />
            <div>Izlazni Dokumenti</div>
          </div>
          <div class="section-square izlazna-posta" v-if="is_permission_inside('project.comunication.email')">
            <pregled-poste :accessToken="accessToken" :key="accessToken" :ulaz="input_mail_id" :izlaz="output_mail_id"
              @refresh-view="resetFileView()" />
          </div>
        </div>
        <div class="opening-folder">
          <div class="open-folder-line">
            <div class="open-folder-line-left">
              <div class="folder-tiny-icon">
                <img src="@/assets/img/tiny-folder.png" />
              </div>
              <div class="folder-open-name">
                {{ folder_name }}
              </div>
              <div v-if="is_permission_inside('project.comunication.create')" class="edit-spis-name add-button add-pen">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <g>
                    <g>
                      <path fill="#7b7b8a"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="open-folder-line-sort" @click="reverseSmjer()">
              Po datumu {{ order_by_tekst }}
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="svg-to-rotate">
                <g>
                  <g>
                    <path fill="#3326ae"
                      d="M9.762 11.682h5.665c.138 0 .25.109.25.244v2.915a.247.247 0 0 1-.25.245H9.762a.247.247 0 0 1-.25-.245v-2.915c0-.135.112-.244.25-.244zm0 4.895h3.201c.138 0 .25.11.25.245v2.915a.247.247 0 0 1-.25.245h-3.2a.247.247 0 0 1-.25-.245v-2.915c0-.135.111-.245.25-.245zm0-10.724h7.828c.138 0 .25.11.25.245v2.914a.248.248 0 0 1-.25.245H9.762a.248.248 0 0 1-.25-.245V6.098c0-.135.112-.245.25-.245zm9.99-2.425h-9.99a.247.247 0 0 1-.25-.245V.269c0-.135.112-.245.25-.245h9.991c.138 0 .25.11.25.245v2.914a.247.247 0 0 1-.25.245zM8.079 6.414H6.382v13.178a.42.42 0 0 1-.423.415H2.545a.419.419 0 0 1-.424-.415V6.414H.426a.424.424 0 0 1-.382-.236.407.407 0 0 1 .052-.439L3.922.153A.426.426 0 0 1 4.252 0c.128 0 .25.056.33.154L8.408 5.74a.407.407 0 0 1 .052.439.424.424 0 0 1-.382.236z" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div id="tree-menu" style="overflow:hidden;">
            <!-- <div class="tree-menu" :key="treemenu_counter"> -->
            <tree-menu v-if="are_files_loaded" :is_editable="permission.create" :key="refresher" :depth="0"
              :item="all_files_rec" :accessToken="accessToken" @node-click="logClick" @multi-select="setMultiFileSelection"
              @folder-create="handleFolderCreateFromFile" @folder-add="handleFolderCreateFromFolder" :smjer="smjer" @file-move="moveFile" @folder-hover="folderHover">
            </tree-menu>
          </div>
          <div v-if="all_files_rec.children.length == 0 && permission.create" class="new-spis-wrapper">
            <div class="new-spis-element" @click="uploadStyling">
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 42 32" fill="none">
                <path
                  d="M33.2862 4.19414C33.3968 4.30546 33.4589 4.45603 33.4589 4.61297C33.4589 4.76991 33.3968 4.92048 33.2862 5.0318L21.2661 17.1247C20.8977 17.4965 20.4592 17.7915 19.976 17.9926C19.4928 18.1937 18.9744 18.2969 18.451 18.2962C17.9277 18.2968 17.4094 18.1936 16.9261 17.9925C16.4429 17.7914 16.0044 17.4964 15.636 17.1247L3.61674 5.03264C3.50585 4.92128 3.44359 4.77054 3.44359 4.61339C3.44359 4.45624 3.50585 4.30549 3.61674 4.19414C3.67122 4.13899 3.73611 4.09519 3.80765 4.06531C3.87919 4.03542 3.95594 4.02003 4.03347 4.02003C4.111 4.02003 4.18776 4.03542 4.2593 4.06531C4.33083 4.09519 4.39572 4.13899 4.45021 4.19414L16.4695 16.2862C16.7292 16.5474 17.038 16.7547 17.3782 16.8962C17.7183 17.0377 18.0831 17.1105 18.4515 17.1105C18.8199 17.1105 19.1846 17.0377 19.5248 16.8962C19.8649 16.7547 20.1737 16.5474 20.4335 16.2862L32.4536 4.19498C32.508 4.13995 32.5729 4.09626 32.6443 4.06645C32.7158 4.03664 32.7924 4.02129 32.8699 4.02129C32.9473 4.02129 33.024 4.03664 33.0954 4.06645C33.1669 4.09626 33.2317 4.13995 33.2862 4.19498V4.19414ZM1.17824 4.38996V22.9715C1.17824 24.7381 2.60753 26.1766 4.36402 26.1766H28.9029V27.3623H4.36402C1.95816 27.3623 0 25.3925 0 22.9715V4.38996C0 1.96904 1.95816 0 4.36402 0H32.5397C34.9456 0 36.9029 1.96987 36.9029 4.39079V19.2536H35.7255V4.39079C35.7255 2.62259 34.2962 1.18577 32.5397 1.18577H4.36402C2.60669 1.18577 1.17824 2.62343 1.17824 4.39079V4.38996ZM30.8268 26.6385C30.8268 26.2745 31.1197 25.9799 31.482 25.9799H35.5029V21.9347C35.5029 21.5715 35.7966 21.277 36.1582 21.277C36.5197 21.277 36.8126 21.5715 36.8126 21.9347V25.9799H40.8343C41.1958 25.9799 41.4887 26.2745 41.4887 26.6385C41.4887 27.0017 41.1958 27.2962 40.8343 27.2962H36.8134V31.3414C36.8134 31.7054 36.5205 32 36.159 32C36.0727 31.9998 35.9874 31.9826 35.9077 31.9494C35.8281 31.9161 35.7558 31.8676 35.695 31.8064C35.6341 31.7453 35.5859 31.6727 35.5531 31.5929C35.5203 31.5132 35.5035 31.4277 35.5038 31.3414V27.2971H31.4828C31.3088 27.2966 31.142 27.2271 31.0191 27.1038C30.8963 26.9805 30.8274 26.8134 30.8276 26.6393L30.8268 26.6385Z"
                  fill="#B8B8C1" />
              </svg>
              <span>Dodajte dokumente</span>
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="multi_file_list.length > 0 && activityFile == null">
        <div class="detalji-spisa section">
          <div class="section-title">Označeni dokumenti
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="scroll-select-docs">
            <div class="detalji-spisa-top" v-for="(singleFile, key) in multi_file_list" :key="key">
            <img class="doc-icon" :src="returnFileType(singleFile.name)" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">{{  singleFile.name  }}</div>
              <div class="detalji-spisa-tiny">
                <span class="tezina">{{  (singleFile.size * 0.000001).toFixed(4)  }}MB</span>
              </div>
            </div>
          </div>
          </div>
          
          <div class="detalji-buttons detalji-buttons-tri" v-if="is_permission_inside('case.comunication.read')">
            <div class="print-button icon-button" @click="openSelectedFiles()">
              <svg id="SVGDoc" width="15" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 15 20">
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>view_icon</title>
                    <path
                      d="M10.11096,14.23522c-0.55015,1.05848 -1.62709,1.72948 -2.80905,1.72948c-1.18184,0 -2.2589,-0.67099 -2.80905,-1.72948c0.55015,-1.05848 1.62721,-1.72948 2.80905,-1.72948c1.18196,0 2.2589,0.67099 2.80905,1.72948zM8.23807,14.23522c0,-0.52977 -0.41997,-0.96079 -0.93615,-0.96079c-0.51618,0 -0.93615,0.43103 -0.93615,0.96079c0,0.52977 0.41997,0.96079 0.93615,0.96079c0.51618,0 0.93615,-0.43103 0.93615,-0.96079zM14.60384,5.39586v12.87476c0,0.95358 -0.75591,1.72935 -1.68502,1.72935h-11.23381c-0.92912,0 -1.68502,-0.77577 -1.68502,-1.72935v-16.52582c0,-0.95358 0.75591,-1.72935 1.68502,-1.72935h7.86364c0.15295,0 0.29933,0.06399 0.40519,0.17716l4.49359,4.80409c0.10037,0.10726 0.1564,0.25033 0.1564,0.39916zM11.24929,14.46601c0.0627,-0.14713 0.0627,-0.31445 0,-0.46158c-0.68569,-1.6108 -2.23517,-2.65158 -3.94738,-2.65158c-1.7122,0 -3.26157,1.04078 -3.94738,2.65158c-0.06258,0.14713 -0.06258,0.31445 0,0.46158c0.68581,1.6108 2.23517,2.65158 3.94738,2.65158c1.7122,0 3.26169,-1.04078 3.94738,-2.65158zM12.3571,6.54889c0,-0.31838 -0.25141,-0.57658 -0.56171,-0.57658h-2.80833v-2.88237c0,-0.31838 -0.25153,-0.57645 -0.56171,-0.57645c-0.31018,0 -0.56171,0.25806 -0.56171,0.57645v3.45895c0,0.31838 0.25153,0.57645 0.56171,0.57645h3.37005c0.3103,0 0.56171,-0.25806 0.56171,-0.57645z"
                      fill="#2b2b41" fill-opacity="1"></path>
                  </g>
                </g>
              </svg>
              Otvori
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="activityFile != null && activityFile.folder != undefined">
        <div class="detalji-spisa section">
          <div class="section-title">Detalji foldera
            <div class="edit-detalji-spisa add-button add-pen" v-if="is_permission_inside('case.comunication.create')"
              @click="openFolderRenamePop()">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <g>
                  <g>
                    <path fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                  </g>
                </g>
              </svg>
            </div>
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="detalji-spisa-top">
            <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">{{  activityFile.name  }}</div>
              <div class="detalji-spisa-tiny">
                <span class="tezina">{{  (activityFile.size * 0.000001).toFixed(4)  }}MB</span>
              </div>
            </div>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">Kreiran</div>
                <div class="case-info-item-info">
                  {{  switchDate(activityFile.createdDateTime)  }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Kreirao:</div>
                <div class="case-info-item-info">
                  <a href="#">{{  activityFile.createdBy.user.displayName  }}</a>
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Posljednje uređivao:</div>
                <div class="case-info-item-info">
                  <a href="#">{{  activityFile.lastModifiedBy.user.displayName  }} ({{
                     switchDate(activityFile.lastModifiedDateTime) 
                    }})</a>
                </div>
              </div>
            </div>
          </div>
          <div class="detalji-buttons detalji-buttons-tri" v-if="is_permission_inside('case.comunication.read')">

            <div class="delete-button icon-button"
              v-if="is_permission_inside('case.comunication.delete') && activityFile.folder.childCount == 0"
              @click="delete_screen = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <g>
                  <g>
                    <path fill="#2b2b41"
                      d="M12.8 5.63v9.455C12.8 16.692 11.5 18 9.904 18H3.52C1.925 18 .626 16.692.626 15.085V5.63c0-.334.27-.605.601-.605h10.971c.332 0 .601.27.601.605zM5.267 8.67c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm4.367 0c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm3.78-5.896V3.95c0 .21-.17.38-.378.38H.389a.379.379 0 0 1-.378-.38V2.774c0-1.01.816-1.83 1.819-1.83h2.618v-.23c0-.393.318-.712.708-.712H8.27c.391 0 .709.32.709.713v.228h2.618c1.003 0 1.819.822 1.819 1.831z" />
                  </g>
                </g>
              </svg>
              Obriši
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="activityFile != null  && activityFile.folder == undefined">
        <div class="detalji-spisa section">
          <div class="section-title">Detalji dokumenta
            <div class="edit-detalji-spisa add-button add-pen" v-if="is_permission_inside('project.comunication.rename')"
              @click="openRenamePop()">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <g>
                  <g>
                    <path fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                  </g>
                </g>
              </svg>
            </div>
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="detalji-spisa-top">
            <img class="doc-icon" :src="returnFileType(activityFile.name)" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">{{ activityFile.name }}</div>
              <div class="detalji-spisa-tiny">
                <span class="tezina">{{ (activityFile.size * 0.000001).toFixed(4) }}MB</span>
              </div>
            </div>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">Kreiran</div>
                <div class="case-info-item-info">
                  {{ switchDate(activityFile.createdDateTime) }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Kreirao:</div>
                <div class="case-info-item-info">
                  <a href="#">{{ activityFile.createdBy.user.displayName }}</a>
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Posljednje uređivao:</div>
                <div class="case-info-item-info">
                  <a href="#">{{ activityFile.lastModifiedBy.user.displayName }} ({{
                      switchDate(activityFile.lastModifiedDateTime)
                  }})</a>
                </div>
              </div>
            </div>
          </div>
          <div class="detalji-buttons detalji-buttons-tri">
            <div class="print-button icon-button" @click="openFile(activityFile.webUrl)"
              v-if="is_permission_inside('project.comunication.read')">
              <svg id="SVGDoc" width="15" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 15 20">
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>view_icon</title>
                    <path
                      d="M10.11096,14.23522c-0.55015,1.05848 -1.62709,1.72948 -2.80905,1.72948c-1.18184,0 -2.2589,-0.67099 -2.80905,-1.72948c0.55015,-1.05848 1.62721,-1.72948 2.80905,-1.72948c1.18196,0 2.2589,0.67099 2.80905,1.72948zM8.23807,14.23522c0,-0.52977 -0.41997,-0.96079 -0.93615,-0.96079c-0.51618,0 -0.93615,0.43103 -0.93615,0.96079c0,0.52977 0.41997,0.96079 0.93615,0.96079c0.51618,0 0.93615,-0.43103 0.93615,-0.96079zM14.60384,5.39586v12.87476c0,0.95358 -0.75591,1.72935 -1.68502,1.72935h-11.23381c-0.92912,0 -1.68502,-0.77577 -1.68502,-1.72935v-16.52582c0,-0.95358 0.75591,-1.72935 1.68502,-1.72935h7.86364c0.15295,0 0.29933,0.06399 0.40519,0.17716l4.49359,4.80409c0.10037,0.10726 0.1564,0.25033 0.1564,0.39916zM11.24929,14.46601c0.0627,-0.14713 0.0627,-0.31445 0,-0.46158c-0.68569,-1.6108 -2.23517,-2.65158 -3.94738,-2.65158c-1.7122,0 -3.26157,1.04078 -3.94738,2.65158c-0.06258,0.14713 -0.06258,0.31445 0,0.46158c0.68581,1.6108 2.23517,2.65158 3.94738,2.65158c1.7122,0 3.26169,-1.04078 3.94738,-2.65158zM12.3571,6.54889c0,-0.31838 -0.25141,-0.57658 -0.56171,-0.57658h-2.80833v-2.88237c0,-0.31838 -0.25153,-0.57645 -0.56171,-0.57645c-0.31018,0 -0.56171,0.25806 -0.56171,0.57645v3.45895c0,0.31838 0.25153,0.57645 0.56171,0.57645h3.37005c0.3103,0 0.56171,-0.25806 0.56171,-0.57645z"
                      fill="#2b2b41" fill-opacity="1"></path>
                  </g>
                </g>
              </svg>
              Otvori
            </div>
            <div class="delete-button icon-button" v-if="is_permission_inside('project.comunication.delete')"
              @click="delete_screen = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <g>
                  <g>
                    <path fill="#2b2b41"
                      d="M12.8 5.63v9.455C12.8 16.692 11.5 18 9.904 18H3.52C1.925 18 .626 16.692.626 15.085V5.63c0-.334.27-.605.601-.605h10.971c.332 0 .601.27.601.605zM5.267 8.67c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm4.367 0c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm3.78-5.896V3.95c0 .21-.17.38-.378.38H.389a.379.379 0 0 1-.378-.38V2.774c0-1.01.816-1.83 1.819-1.83h2.618v-.23c0-.393.318-.712.708-.712H8.27c.391 0 .709.32.709.713v.228h2.618c1.003 0 1.819.822 1.819 1.831z" />
                  </g>
                </g>
              </svg>
              Obriši
            </div>
            <!-- <div
              class="print-button icon-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
              >
                <g>
                  <g>
                    <path
                      fill="#2b2b41"
                      d="M16.206 3.132H3.97a.387.387 0 0 1-.387-.387V1.738c0-.94.763-1.704 1.704-1.704h9.602c.941 0 1.704.763 1.704 1.704v1.007a.387.387 0 0 1-.387.387zM20 6.462v7.279c0 1.153-.938 2.09-2.09 2.09h-1.317v-3.097a2.79 2.79 0 0 0-2.788-2.788H6.371a2.79 2.79 0 0 0-2.788 2.788v3.098H2.267A2.093 2.093 0 0 1 .176 13.74v-7.28c0-1.152.938-2.09 2.09-2.09H17.91c1.153 0 2.091.938 2.091 2.09zM4.823 8.088a.93.93 0 1 0-1.86 0 .93.93 0 0 0 1.86 0zm9.911 4.646v4.337a.93.93 0 0 1-.929.929H6.371a.93.93 0 0 1-.93-.93v-4.336a.93.93 0 0 1 .93-.929h7.434a.93.93 0 0 1 .93.93z"
                    />
                  </g>
                </g>
              </svg>
              Print
            </div> -->
            <!-- <div class="preseli-button icon-button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="18"
                viewBox="0 0 19 18"
              >
                <g>
                  <g>
                    <path
                      fill="#2b2b41"
                      d="M9.262 5.305c2.098 0 3.799 1.653 3.799 3.692 0 2.04-1.701 3.693-3.799 3.693s-3.799-1.653-3.799-3.693c0-2.039 1.701-3.692 3.799-3.692zm-3.757-1.38a.516.516 0 0 1 .117-.576L8.878.15a.553.553 0 0 1 .768 0l3.256 3.2c.155.151.202.378.117.575a.542.542 0 0 1-.5.326H6.005a.542.542 0 0 1-.501-.326zm7.013 9.82c.22 0 .418.128.501.325a.516.516 0 0 1-.117.575l-3.256 3.2a.549.549 0 0 1-.384.155.549.549 0 0 1-.384-.155l-3.256-3.2a.516.516 0 0 1-.117-.575.542.542 0 0 1 .501-.325zM.16 9.37a.517.517 0 0 1 0-.746L3.452 5.46a.551.551 0 0 1 .59-.114.527.527 0 0 1 .336.487v6.33a.527.527 0 0 1-.335.488.554.554 0 0 1-.591-.115zm18.206-.746a.517.517 0 0 1 0 .746l-3.292 3.165a.554.554 0 0 1-.592.115.527.527 0 0 1-.335-.488v-6.33c0-.213.132-.406.335-.487a.554.554 0 0 1 .592.114z"
                    />
                  </g>
                </g>
              </svg>
              Preseli
            </div> -->
          </div>
          <!-- <div class="detalji-buttons-obrisi">

          </div> -->
        </div>
      </div>
    </div>
    <v-dialog v-model="delete_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Jeste li sigurni da želite obrisati datoteku?
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="deleteFile(activityFile.id)"> Obriši </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="upload_fold_model" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Odaberite folder za upload.
        </v-card-title>
        <tree-folders :key="refresher" :depth="0" :item="all_files_rec" :accessToken="accessToken"
          @node-click="setUploadFolder" :smjer="smjer"></tree-folders>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="delete_screen = false">
            Odaberi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newFolderPop" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Novi folder
        </div>
        <v-text-field class="universal-vdialog-textfield" label="Naziv foldera" v-model="newDirectoryName">
        </v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="newFolderPop = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="createFolder()"> Kreiraj </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newFilePop" width="540">
      <v-card>
        <v-card-title class="headline grey lighten-2" id="main-file-upload">
          Odredišni podfolder
        </v-card-title>
        <tree-folders :key="refresher" :depth="0" :item="all_files_rec" :accessToken="accessToken"
          @node-click="setUploadFolder" :smjer="smjer"></tree-folders>
        <!-- <v-card-title class="headline grey lighten-2">
          Novi dokument
        </v-card-title> -->
        <div>
          <div class="
              flex
              w-full
              h-screen
              items-center
              justify-center
              text-center
              drop-document-main-wrapper
            " id="app">
            <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave"
              @drop="drop">
              <div class="loading-spinner"></div>
              <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute drag-drop" @change="onChange" ref="file"
                accept=".pdf" />

              <label for="assetsFieldHandle" class="block cursor-pointer drop-document-area">
                <div>
                  <div class="select-file-message-wrapper">
                    <div class="select-file-message">
                      Prenesi dokument direktno ili odaberi s računala
                    </div>
                  </div>
                  <div class="button-select-file-wrapper">
                    <div class="button-default button-select-file">
                      Odaberi s računala
                    </div>
                  </div>
                </div>
              </label>
              <div class="opening-folder opening-radni-dokumenti section">
                <div class="inside-radni-dokumenti">
                  <draggable :class="filelist.length > 3 ? 'row-multiple' : 'row'" :sort="false">
                    <div v-for="upFile in filelist" :key="upFile.id">
                      <div :class="[
                        filelist.length > 3
                          ? 'radni-dokument-inside-multiple'
                          : 'radni-dokument-inside',
                        'preneseni-dokument',
                      ]" draggable="true">
                        <div :class="[
                          filelist.length > 3
                            ? 'document-image-wrapper-multiple'
                            : 'document-image-wrapper',
                        ]">
                          <img class="preneseni-dokument-image" :src="returnFileType(upFile.name)" />
                          <div v-show="filelist.length < 4" class="remove-document" @click="deleteFileInSpis(upFile)">
                            <span>X</span>
                          </div>
                        </div>
                        <div class="preneseni-dokument-title">
                          {{ upFile.name }}
                        </div>

                        <div v-show="filelist.length > 3" class="remove-document-multiple"
                          @click="deleteFileInSpis(upFile)">
                          <span>X</span>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions>
          <div class="button-upload-wrapper">
            <div class="button-default button-create" @click="!is_waiting_on_insert ? addNewUploadFile() : ''">
              <svg v-if="is_waiting_on_insert" class="update-event-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>
              <span v-else>Upload</span>
            </div>
          </div>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
        {{ snackText }}
        <div v-for="(od,key) in odbacene" :key="key">{{od.name}}</div>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            U redu
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
    <v-dialog v-model="renameFilePop" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title" v-if="activityFile">
          Preimenujte naziv datoteke
        </div>
        <v-text-field class="universal-vdialog-textfield" label="Naziv bez nastavka" v-model="new_file_name">
        </v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="renameFilePop = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="renameFile()"> Primjeni </div>
        </div>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <div>Preuzimanje dokumenta u tijeku</div>
      <v-progress-linear color="light-blue darken-4" height="20" :value="overlay_progress" striped></v-progress-linear>
    </v-overlay>
    <v-dialog v-model="$store.state.spis_overlay_open" width="300">
      <DataLoader :is_on="pic_loading" />
      <div id="f-u-vuetify"></div>
      <img
        v-show="!pic_loading" :src="$store.state.spis_active_pic != null && $store.state.spis_active_pic.thumbnails.length > 0 ? $store.state.spis_active_pic.thumbnails[0].large.url : ''" @load="onImgLoad">
    </v-dialog>
    <v-snackbar v-model="snackbar_move" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
      {{  snackText  }}
      <div v-for="(od, key) in odbacene" :key="key">{{  od  }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar_move = false">
          U redu
        </v-btn>
      </template>
    </v-snackbar>
    <!-- create new folder popup -->
  </div>
</template>

<script>
import share from "@/apiCallers/sharepoint";
import auth from "@/services/auth";
import $ from "jquery";
import gsap from "gsap";
import TreeMenu from "@/components/generalComponents/TreeMenu.vue";
import moment from "moment";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import draggable from "vuedraggable";
import graph from "@/services/graph.js";
import PregledPoste from "@/components/caseComponents/PregledPoste.vue";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import permissioner from "@/services/permissioner.js"
import {getProjData} from "@/router/project/handler"
import DataLoader from '@/components/generalComponents/DataLoader'




export default {
  components: {
    TreeMenu,
    TreeFolders,
    draggable,
    ProjTab,
    PregledPoste,
    DataLoader,
  },
  data() {
    return {
       //moving 
       moving_file: {
        parentReference: {
          id: "",
        },
        name: "",
      },
      //upload folder start
      newDirectoryName: "",
      newDirectoryParentId: "",
      newFolderPop: false,
      uploadNode: null,
      //upload folder end
      overlay: false,
      overlay_progress: 0,
      popis_preuzimanja_spisa: [],
      newFilePop: false,
      upload_fold_model: false,
      selected_upload_folder: null,
      order_by_tekst: "silazno",
      side_spis_view: false,
      selected_spis: {},
      treemenu_counter: 1,
      smjer: true,
      delete_screen: false,
      trigg: true,
      activityFile: null,
      multi_file_list : [],
      tree: {},
      accessToken: "",
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      folders: [],
      proj_data: {broj_projekta:""},
      filelist: [],
      snackbar: false,
      snackTimeout: 10000,
      snackText: '',
      odbacene:[],
      //ulazna i izlazna pošta
      input_mail_id: "",
      output_mail_id: "",
      chosen_type: 0,
      is_waiting_on_insert: false,
      active_mail_type: "",

      all_files_rec: null,
      are_files_loaded: false,
      refresher: 1,

      new_file_name: "",
      renameFilePop: false,


      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      },
      folder_name: '',
      anim_duration: 0.5,
      overlay_thumbnail: false,
      pic_loading:true,
      snackbar_move:false,
    };
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);

    await getProjData(this.$route.params.uid).then(async (response) => {
      this.proj_data = response;
      this.setPostFolder(this.proj_data.root_ulazna);

      var validator_array = this.proj_data.connect_project_odvjetnik.filter(
        (p) => {
          return this.$store.state.logged_in_user.uid === p.odvjetnik.uid;
        }
      );

      // treba nadograditi sa novim user_role logikom
      if (validator_array.length == 0 && this.$store.state.logged_in_user.user_role.id != 1) {
        this.$router.push({ name: "NotPartOfCase" });
      }

      else if (this.$store.state.logged_in_user.user_role.id != 1) {
        permissioner.save_project_permission(this.$route.params.uid, validator_array[0].project_odvjetnik_status.project_permission.map((p) => p.permission_id));
      }


      this.input_mail_id = this.proj_data.root_ulazna;
      this.output_mail_id = this.proj_data.root_izlazna;
    });
  },
  watch:{
    "$store.state.spis_overlay_open": {
      handler: function () {
        if (!this.$store.state.spis_overlay_open) {
          this.pic_loading = true;
        }
      }
    }
  },
  methods: {
    onImgLoad(){
      this.pic_loading = false;
      setTimeout(() => {
        var getFuckingParent = document.getElementById("f-u-vuetify");
          $(getFuckingParent.parentElement).addClass('setDialogWidth');
      }, 10);
    },
    closeDetalji(){
      this.activityFile=null;
      this.multi_file_list = [];
      $('.inside-folder').removeClass("eye_clicked");
    },
    is_permission_inside(wanted_permission) {
      return permissioner.check_project_permission(wanted_permission)
    },
    folderHover(node) {
      if (node == null) {
        this.moving_file.parentReference.id = "";
        this.moving_file.name = "";
      } else {
        this.moving_file.parentReference.id = node.id;

      }
    },

    openRenamePop() {
      var full_old_name = this.activityFile.name.split(".");
      full_old_name.pop();
      this.new_file_name = full_old_name.join(".");
      this.renameFilePop = true;



    },
    async setPostFolder(mail_type) {
      this.active_mail_type = mail_type;
      this.selected_upload_folder = null;
      await this.resetFileView();
      if ($('#tree-menu').height() > 960) {
        this.anim_duration = 0.4;
      }
      else {
        this.anim_duration = $('#tree-menu').height() * 0.00045;
      }
      gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
    },

    //Rename activity file
    renameFile() {
      var idx_ext = this.activityFile.name.split(".").length - 1;
      var extension = this.activityFile.name.split(".")[idx_ext];
      var new_name_ext = this.new_file_name + "." + extension;

      console.log("Old name", this.activityFile.name);
      console.log("New name", new_name_ext);
      const driveItem = {
        name: new_name_ext,
      };
      share.renameSingleDoc(this.accessToken, this.$route.params.uid, this.activityFile.id, driveItem).then((resp) => {
        this.activityFile = null;
        this.multi_file_list=[];
        this.renameFilePop = false;
        this.new_file_name = ""
        this.resetFileView()
      })

    },
    moveFile(node) {
      this.odbacene = [];
      this.snackbar_move = false;
      if(this.multi_file_list.length == 0)
      {
        this.multi_file_list.push(node);
      }
      console.log(this.multi_file_list)
      for (let i = 0; i < this.multi_file_list.length; i++) {
        let active_move_file = this.multi_file_list[i];
        console.log(this.multi_file_list[i],active_move_file)
        if (active_move_file.parentReference.id != this.moving_file.parentReference.id && this.moving_file.parentReference.id != "") {
          this.moving_file.name = active_move_file.name
          var path = "/drive/items/" + active_move_file.id;

          share
            .moveDriveItem(
              this.accessToken,
              this.$route.params.uid,
              active_move_file.parentReference.id,
              path,
              this.moving_file
            )
            .then(() => {
              if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = []
                setTimeout(async () => {
                  this.resetFileView();
                }, 200);
              }
            })
            .catch((err)=>{
              if(err.response.status == 409){
                this.odbacene.push(active_move_file.name);
                this.snackText = 
                  "Sljedeće datoteke nisu prenesene jer u odredišnom folderu postoji datoteka sa istim nazivom:";
                this.snackbar_move = true;
              }
              else console.log(err)
            })
            .finally(()=>{
              if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = []
                setTimeout(async () => {
                  this.resetFileView();
                }, 200);
              }
            });
        }else{
          if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = []
                setTimeout(async () => {
                  this.resetFileView();
                }, 200);
              }
        }
      }

    },

    //dodajem klasu na upload wrapper da ga mogu lakše modificirati, jebem te vuetify
    uploadStyling() {
      this.newFilePop = true;
      setTimeout(function () {
        var upl = document.getElementById("main-file-upload");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(upl.nextSibling).addClass("spis-megawrapper-parent");
        $('.spis-megawrapper').removeClass('active');
        $('.main-file-upload-wrapper').find('.spis-megawrapper:first').click();
      }, 100);
    },

    //RESET OF DATA VIEW
    async resetFileView() {
      this.are_files_loaded = false;
      this.newFilePop = false;
      this.treemenu_counter++;
      this.tree.nodes = [];
      this.pdf_merge_file_list = [];
      this.treemenu_counter++;
      this.filelist = [];
      let rec_data = await this.get_recursive_data(this.active_mail_type);
      let first_root = await this.getRootSpisFile(this.active_mail_type);
      first_root.children = rec_data;
      this.all_files_rec = first_root;
      this.folder_name = first_root.item.name;
      this.are_files_loaded = true;
    },

    //COLLECT ALL PDF-s and send them into mergeing process
    async spisToPDF() {
      if (this.pdf_mergeing == false) {
        this.pdf_mergeing = true;
        await share
          .mergeFiles(this.pdf_merge_file_list, 0, Date.now())
          .then(async (response) => {
            let tmp_file_name = response.data;

            await share
              .mergeFilesFinal(0, tmp_file_name)
              .then(async (resp) => {
                var newBlob = new Blob([resp.data], {
                  type: "application/pdf",
                });
                var data = window.URL.createObjectURL(newBlob);

                var link = document.createElement("a");
                link.href = data;
                link.download = this.selected_spis.ime + ".pdf";
                link.click();
                setTimeout(function () {
                  // For Firefox it is necessary to delay revoking the ObjectURL
                  window.URL.revokeObjectURL(data);
                }, 100);
                this.pdf_mergeing = false;
              })
              .then(async () => {
                await share.mergeFilesClear(tmp_file_name);
              });
          });
      }
    },
    // Add some visual fluff to show the user can drop its files
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    // Clean up after cursor leaves
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    openSelectedFiles(){  
      for(let i = 0; i<this.multi_file_list.length; i++)
      {
        window.open(this.multi_file_list[i].webUrl)
      }
    },
    // Reaction to event drop, that checks and controls all data
    onChange() {
      this.snackbar = false;
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      let filt_tmp_file_list = tmp_file_list.filter((file)=>file.size < 57671680);
      const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
      if (num_odbacenih != 0) {
        this.snackbar = true;
        this.odbacene = tmp_file_list.filter((file)=>file.size >= 57671680);
        this.snackText =
          "Zbog ograničenja Sharepoint-a odbačene su sljedeće datoteke veće od 55MB:";
      }
      tmp_file_list = filt_tmp_file_list;

      let pdf_tmp_file_list = tmp_file_list.filter((p) => {
        let tmp_name_list = p.name.split(".");
        return tmp_name_list[tmp_name_list.length - 1].includes("pdf");
      });
      //check all the inserted files and remove all that don't comply with pdf format END
      const len_dif = tmp_file_list.length - pdf_tmp_file_list.length;
      if (len_dif > 0) {
        this.odbacene = [];
        this.snackbar = true;
        this.snackText =
          "Odbačeno je " + len_dif + " datoteka koje nisu PDF formata.";
      }
      tmp_file_list = pdf_tmp_file_list;
      if ([...this.$refs.file.files].length)
        this.filelist = this.filelist.concat(tmp_file_list);
    },
    //Remove file from list on X
    closePrint() {
      document.body.removeChild(this.__container__);
    },

    //
    setPrint() {
      contentWindow.__container__ = this;
      contentWindow.onbeforeunload = this.closePrint();
      contentWindow.onafterprint = this.closePrint();
      contentWindow.focus(); // Required for IE
      contentWindow.print();
    },
    async reverseSmjer() {
      this.smjer = !this.smjer;
      // TweenMax.to('.open-folder-line-sort svg', 1, {rotation:360, ease:Linear.easeNone, repeat:-1})

      gsap.to('#tree-menu', this.anim_duration, { height: 0, ease: "none" });
      setTimeout(async () => {
        if (this.smjer) {
          gsap.to('.svg-to-rotate', 0, { rotation: 0 });
          this.order_by_tekst = "silazno";
        } else {
          gsap.to('.svg-to-rotate', 0, { rotation: 180 });
          this.order_by_tekst = "uzlazno";
        }
        await this.resetFileView();
        gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
      }, this.anim_duration * 1000);
    },
    openFile(linkToFile) {
      window.open(linkToFile);
    },
    deleteFile(fileId) {
      this.delete_screen = false;
      var path = "/drive/items/" + fileId;
      share
        .deleteFile(this.accessToken, this.$route.params.uid, path)
        .then(() => {
          this.activityFile = null;
          this.multi_file_list=[];
          this.resetFileView();
        });
    },
    logClick(node) {
      this.activityFile = node;
      this.multi_file_list = [];
      this.multi_file_list.push(node)
      // this.getPreview();
      this.side_spis_view = false;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
    },
    setMultiFileSelection(node) {
      this.activityFile = null;
      // this.getPreview();
      this.side_spis_view = true;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });

      let tmp_index = this.multi_file_list.findIndex((p) => {
        return p.id == node.id;
      });
      if (tmp_index == -1) {
        console.log("Datoteka nije u popisu ", tmp_index)
        this.multi_file_list.push(node);
      } else {
        console.log("Datoteka je u popisu ", this.multi_file_list,)
        $('#single-file-' + node.id).removeClass("eye_clicked");
        this.multi_file_list.splice(tmp_index, 1);
      }

    },

    // CREATE FOLDER FUNCTIONS START
    handleFolderCreateFromFile(node) {
      if (this.is_permission_inside("project.comunication.create")) {
        let direcNameArray = node.name.split(".");
        if (direcNameArray.length > 1) {
          direcNameArray.pop();
        }
        let tmp_dir_name = direcNameArray.join("");
        this.newDirectoryName = tmp_dir_name;
        this.newFolderPop = true;
        this.newDirectoryParentId = node.parentReference.id;
        this.uploadNode = node;
      }
    },
    //CREATE NEW FOLDER WHEN CLICKED ON ANOTHER FOLDER
    handleFolderCreateFromFolder(node) {
      if (this.is_permission_inside("project.comunication.create")) {
        this.newDirectoryName = "";
        this.newFolderPop = true;
        this.newDirectoryParentId = node.id;

        this.uploadNode = null;
      }
    },
    //Connection to api that sends all necessery identifications and nodes to sharepoint site onedrive
    createFolder() {
      share
        .createFolderDocs(
          this.accessToken,
          this.$route.params.uid,
          this.newDirectoryParentId,
          this.newDirectoryName
        )
        .then((resp) => {
          if (this.uploadNode != null) {
            var path = "/drive/items/" + this.uploadNode.id;
            var tmpDriveItem = {
              parentReference: {
                id: resp.data.id,
              },
              name: this.uploadNode.name,
            };

            share
              .moveDriveItem(
                this.accessToken,
                this.$route.params.uid,
                resp.data.id,
                path,
                tmpDriveItem
              )
              .then(() => {
                this.resetFileView();
              });
          } else {
            this.resetFileView();
          }
          this.newFolderPop = false;
        });
    },
    // CREATE FOLDER FUNCTIONS END

    //inside upload form set the folder id
    setUploadFolder(node) {
      this.selected_upload_folder = node.id;
      console.log("New selected upload folder", node);
    },

    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      share.addDocumentInSpis(
        this.accessToken,
        this.$route.params.uid,
        this.selectedFolder,
        file
      );
    },
    async addNewUploadFile() {
      if (this.filelist.length != 0) {
        const formData = new FormData();
        this.filelist.forEach((fl) => {
          console.log(fl);
          formData.append("files", fl);
        });
        if (this.selected_upload_folder == null) {
          if (this.chosen_type == 0) {
            this.selected_upload_folder = this.input_mail_id;
          }
          else {
            this.selected_upload_folder = this.output_mail_id;
          }
        }
        formData.append("token", this.accessToken);
        formData.append("groupId", this.$route.params.uid);
        formData.append("sid", this.selected_upload_folder);
        // formData.append("name", esc_filename);
        // appending file
        this.file_upload_text = "Uploading...";
        this.is_waiting_on_insert = true;
        await share
          .addDocumentInSpis(formData)
          .then(() => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            this.resetFileView();
            document.getElementById("assetsFieldHandle").value = "";

          })
          .catch((err) => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            document.getElementById("assetsFieldHandle").value = "";

          });
      }
    },
    //PUSH ROUTE TO CASE SPIS BASED ON ID
    routeToSpis(sid) {
      this.$router.push("/case/" + this.$route.params.uid + "/spisi/" + sid);
      this.side_spis_view = true;
      this.activityFile = null;
    },

    //GET ALL DOCS IN DRIVE BASED ON drive id
    getAllDocsById(sid) {
      var ret_files = [];
      share
        .getDocumentsInSpis(
          this.accessToken,
          this.$route.params.uid,
          sid,
          this.smjer
        )
        .then((response) => {
          response.data.forEach((dat) => {
            ret_files.push(dat);
          });
        });

      return ret_files;
    },
    // DELETE ALL FILES IN SPIS
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },
    // RETURN APPROPRIATE FILE ICON
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext];
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xls":
          return_val = require("@/assets/img/xls_icon.svg");
          break;

        default:
          return_val = require("@/assets/img/doc_icon.svg");
          break;
      }
      return return_val;
    },
    //SWITCH TO NEW VIEW BY ROUTE
    switchTab(nastavak) {
      this.$router.push("/case/" + this.$route.params.uid + "/" + nastavak);
    },
    //APPROPRIATE DATE TIME FORMAT FOR DISPLAY
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
    //RETURNS FOLDER IN PARRENT DIRECTORY
    getfoldersById(sid) {
      var ret_fold = [];
      share
        .getDocumentsInSpis(
          this.accessToken,
          this.$route.params.uid,
          sid,
          this.smjer
        )
        .then((response) => {
          response.data.forEach((dat) => {
            if (dat.folder != undefined) {
              ret_fold.push(dat);
            }
          });
        });
      return ret_fold;
    },

    //GET INITIAL
    async get_recursive_data(id) {
      var ret_fold = [];
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      await graph
        .getFileChildren(this.$route.params.uid, id)
        .then((response) => {
          if (response.value.length > 0) {
            let tmp_arr_files = response.value.filter((p) => p.name.toString().endsWith(".pdf") || p.folder != undefined);
            if (this.smjer === true) {
              tmp_arr_files.sort(function (a, b) {
                return new Date(b.createdDateTime) - new Date(a.createdDateTime);
              });
            } else {
              tmp_arr_files.sort(function (a, b) {
                return new Date(a.createdDateTime) - new Date(b.createdDateTime);
              });
            }
            tmp_arr_files.forEach(async (dat) => {
              let tmp_ret_item = {
                item: dat,
                children: [],
              };
              if (dat.folder != undefined) {
                tmp_ret_item.children = await this.get_recursive_data(dat.id);
              } else {
                this.pdf_merge_file_list.push(
                  dat["@microsoft.graph.downloadUrl"]
                );
              }
              ret_fold.push(tmp_ret_item);
            });
          }
        });
      return ret_fold;
    },
    async getRootSpisFile(sid) {
      let tmp_first = {
        item: {},
        children: [],
      };
      await graph
        .getSingleFile(this.$route.params.uid, sid)
        .then(async (response) => {
          tmp_first.item = response;
        });
      return tmp_first;
    },
  },
  mounted() {
    document.body.classList.add("posta-page");
    //za hendlanje desnog spis detalji prozorčića
    setTimeout(function () {
      $(window).scroll(function () {
        var brojDokumenata = $(".spis-megawrapper").length;
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        var percent =
          ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
        if (percent > 20 || window.matchMedia("(min-width: 1199px) and (max-width: 1570px)").matches) {
          gsap.to(".spisi-right", 0.3, { marginTop: "-12rem" });
        }
        if (percent < 20) {
          gsap.to(".spisi-right", 0.3, { marginTop: "5rem" });
        }
      }); //end scroll function
    }, 1700);
  },
  destroyed() {
    document.body.classList.remove("posta-page");
    setTimeout(() => {
      $(window).off();
    }, 1700);
  },
};
</script>

<style>
</style>